import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import "./LanguageSelector.css";

interface LanguageSelectorProps {
  variant?: "floating" | "footer";
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  variant = "floating",
}) => {
  const { language, changeLanguage } = useLanguage();

  if (variant === "footer") {
    return (
      <div className="language-selector language-selector--footer">
        <span className="language-selector-label">Language:</span>
        <button
          className={`lang-link ${language === "it" ? "active" : ""}`}
          onClick={() => changeLanguage("it")}
          aria-label="Cambia in Italiano"
        >
          IT
        </button>
        <span className="language-separator" aria-hidden="true">
          |
        </span>
        <button
          className={`lang-link ${language === "en" ? "active" : ""}`}
          onClick={() => changeLanguage("en")}
          aria-label="Switch to English"
        >
          EN
        </button>
      </div>
    );
  }

  return (
    <div className="language-selector language-selector--floating">
      <button
        className={`lang-button ${language === "en" ? "active" : ""}`}
        onClick={() => changeLanguage("en")}
        aria-label="Switch to English"
      >
        🇬🇧 EN
      </button>
      <button
        className={`lang-button ${language === "it" ? "active" : ""}`}
        onClick={() => changeLanguage("it")}
        aria-label="Cambia in Italiano"
      >
        🇮🇹 IT
      </button>
    </div>
  );
};

export default LanguageSelector;
